// import { axios } from "vue/types/umd";

// import { axios } from "vue/types/umd";

// import { axios } from "vue/types/umd";

export const Student = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    preload_matric_service(context, details) {
      context.dispatch("spinner/showSpinner", null, { root: true });
      return new Promise((res, rej) => {
        axios
          .post("/admin/preload-matno", details)
          .then((response) => {
            context.dispatch("spinner/hideSpinner", null, { root: true });
            res(response);
          })
          .catch((err) => {
            context.dispatch("spinner/hideSpinner", null, { root: true });
            rej(err);
          });
      });
    },
  },
};
